<template>
  <div id="wowy_combo_playing_time_distribution" class="border-padding">
  <main>
    <div class="row">
      <div class="col-md-4" v-if="season_dropdown.data != undefined">
        <season-select v-model="seasons_selected" :options="season_dropdown"></season-select>
      </div>

      <div class="col-md-2" v-if="season_type_dropdown.data != undefined">
        <season-type-select v-model="season_type_selected" :options="season_type_dropdown"></season-type-select>
      </div>

      <div class="col-md-1" v-if="team_dropdown.data != undefined">
        <team-select v-model="team_selected" :options="team_dropdown" :inputFunc="changePlayers" :preselectFirst="true" :allowEmpty="false"></team-select>
      </div>

      <div class="col-md-4">
        <label class="typo__label">Players</label>
        <multiselect
          v-model="players_selected"
          :options="players"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="true"
          :hide-selected="true"
          :preserve-search="true"
          placeholder=""
          label="name"
          track-by="playerId"
          :preselect-first="false">
          <template slot="tag" slot-scope="props"><span class="custom__tag"><span>{{ props.option.name }}</span><span class="custom__remove" @click="props.remove(props.option)">❌</span></span></template>
        </multiselect>
      </div>
    </div>

    <div class="border-padding">
      <input v-model="only_show_all_players_on" type="checkbox"> Only Show Times When All Selected Players Are On
    </div>

    <div class="border-padding">
      <button class="" v-on:click="changeStats()">Show Chart</button>
    </div>

    <div v-if="loading">
      Loading.....
    </div>
    <p style="color:red;" v-if="show_error_message">Error Getting Results</p>

    <div id="chart_container" class="row margin-padding">
      <svg id="chart" width="800" height="600"></svg>
      <svg id="legend" width="500" height="600"></svg>
    </div>

  </main>
  </div>
</template>

<script>
import axios from 'axios'
import GetDropdownOptions from './mixins/get_dropdown'
import Multiselect from 'vue-multiselect'
import SeasonTypeSelect from './mixins/SeasonTypeSelect.vue'
import SeasonSelect from './mixins/SeasonSelect.vue'
import TeamSelect from './mixins/TeamSelect.vue'
import PlayerWowySelect from './mixins/PlayerWowySelect.vue'
import { season, seasonType } from './mixins/dropdowns'
const d3 = require('d3')

export default {
  name: 'WowyComboPlayingTime',
  components: {
    Multiselect,
    SeasonTypeSelect,
    SeasonSelect,
    TeamSelect,
    PlayerWowySelect
  },
  mixins: [SeasonTypeSelect, SeasonSelect, TeamSelect, PlayerWowySelect, GetDropdownOptions, season, seasonType],
  data () {
    return {
      loading: false,
      season_dropdown: {},
      seasons_selected: [],
      season_type_dropdown: {},
      season_type_selected: undefined,
      season_selected_string: '',
      players_selected: [],
      players_selected_string: '',
      players: [],
      team_dropdown: {},
      team_selected: undefined,
      show_error_message: false,
      only_show_all_players_on: false,
      api_endpoint: 'get-wowy-combo-playing-time-distribution/'
    }
  },
  created () {
    this.loadData()
  },
  watch: {
    '$route': 'updateData',
    '$parent.league': 'changeLeague'
  },
  methods: {
    changeLeague () {
      d3.selectAll('svg > *').remove()
      this.table_data = []
      this.seasons_selected = []
      this.players_selected = []
      this.$router.push({name: 'wowy_combo_playing_time_distribution', params: {league: this.$parent.league, type: this.$route.params.type}})
    },
    checkIfStatsShouldBeLoaded (response) {
      this.getPlayers([this.displayPlayersSelected])
      if (this.$route.query.TeamId && this.$route.query.Season && this.$route.query.SeasonType && this.$route.query.PlayerIds) {
        this.getStats()
      }
    },
    loadData () {
      this.getDropdown([this.setSeasonDropdown, this.setSeasonTypeDropdown, this.setTeamDropdown, this.checkIfStatsShouldBeLoaded])
      if (this.$route.query.OnlyShowAllPlayersOn) {
        this.only_show_all_players_on = true
      }
    },
    updateData () {
      if (this.$route.query.TeamId && this.$route.query.Season && this.$route.query.SeasonType && this.$route.query.PlayerIds) {
        this.getStats()
      } else {
        this.loadData()
      }
    },
    getPlayersSelectedString () {
      this.players_selected_string = ''
      for (var i = 0; i < this.players_selected.length; i++) {
        if (i === 0) {
          this.players_selected_string += this.players_selected[i].playerId
        } else {
          this.players_selected_string += ',' + this.players_selected[i].playerId
        }
      }
    },
    displayPlayersSelected () {
      if (this.$route.query.PlayerIds) {
        var playerIds = this.$route.query['PlayerIds'].split(',')
        playerIds.forEach((selectedPlayerId) => {
          this.players.forEach((player) => {
            if (player.playerId === selectedPlayerId) {
              this.players_selected.push(player)
            }
          })
        })
      }
    },
    changePlayers () {
      this.players_selected = []
      this.season_selected_string = this.getSeasonsSelectedString()
      if (this.season_dropdown.data.length > 0 && this.team_selected) {
        this.getPlayers([])
      }
    },
    changeStats () {
      var params = {}

      this.season_selected_string = this.getSeasonsSelectedString()
      params[this.$seasonParam] = this.season_selected_string
      params[this.$seasonTypeParam] = this.season_type_selected.id

      if (this.team_selected) {
        params[this.$teamIdParam] = this.team_selected.id
      }
      this.getPlayersSelectedString()
      params['PlayerIds'] = this.players_selected_string

      if (this.only_show_all_players_on) {
        params['OnlyShowAllPlayersOn'] = this.only_show_all_players_on
      }

      this.$router.push({name: 'wowy_combo_playing_time_distribution', query: params})
    },
    getStats () {
      this.show_error_message = false
      d3.selectAll('svg > *').remove()
      var params = this.$route.query

      if (params.Season && params.SeasonType && params.TeamId && params.PlayerIds) {
        this.loading = true
        axios.get(process.env.API_BASE_URL + this.api_endpoint + this.$route.params.league, {
          params: params
        })
          .then((response) => {
            if (!response.data.error) {
              this.results = response.data.results
              this.max_y_axis_value = response.data.max_y_axis_value
              this.addChart(this.results, this.max_y_axis_value)
            } else {
              this.show_error_message = true
            }
            this.loading = false
          }, (error) => {
            this.show_error_message = true
            this.loading = false
            this.error = error
          })
      }
    },
    addChart (data, maxYAxisValue) {
      var svg = d3.select('svg#chart')
      var margin = {top: 20, right: 20, bottom: 30, left: 50}
      var width = +svg.attr('width') - margin.left - margin.right
      var height = +svg.attr('height') - margin.top - margin.bottom
      var g = svg.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')

      var tooltip = d3.select('div#chart_container').append('div').attr('class', 'wowy-combo-playing-time-tooltip')

      var x = d3.scaleBand()
        .rangeRound([0, width])
        .paddingInner(0.05)
        .align(0.1)

      var y = d3.scaleLinear()
        .rangeRound([height, 0])

      var wowyCombos = []

      for (var i = 0; i < data.length; i++) {
        data[i]['GameNumber'] = i + 1
        for (var j = 0; j < data[i].Possessions.length; j++) {
          data[i].Possessions[j]['Date'] = data[i].Date
          data[i].Possessions[j]['GameNumber'] = i + 1
          data[i].Possessions[j]['Opponent'] = data[i].Opponent
          var wowyCombo = data[i].Possessions[j].WowyCombo
          data[i].Possessions[j]['WowyCombo'] = wowyCombo
          if (wowyCombos.indexOf(wowyCombo) === -1) {
            wowyCombos.push(wowyCombo)
          }
        }
      }

      x.domain(data.map(function (d) { return d.GameNumber }))
      y.domain([0, maxYAxisValue / 60])
      var colours = ['#de8a30', '#586cd8', '#59b542', '#9455cd', '#a2b03f', '#e460c8', '#6bbc75', '#b2359b', '#447e45', '#db4188', '#4cbdac', '#dd4060', '#52a7d8', '#d85329', '#4e77bd', '#cca337', '#cc7edd', '#7b6f29', '#a597e0', '#a1562a', '#7e569f', '#caa169', '#cd6caa', '#e77f5f', '#cd8cbe', '#b93836', '#9f4373', '#de8382', '#a34b55', '#e780a4']
      var ordinalScale = d3.scaleOrdinal()
        .domain(wowyCombos)
        .range(colours)

      g.append('g')
        .selectAll('g')
        .data(data)
        .enter().append('g')
        .selectAll('rect')
        .data(function (d) { return d.Possessions })
        .enter().append('rect')
        .attr('x', function (d) { return x(d.GameNumber) })
        .attr('y', function (d) { return y(d.EndTime / 60) })
        .attr('fill', function (d) { return ordinalScale(d.WowyCombo) })
        .attr('height', function (d) { return y(d.StartTime / 60) - y(d.EndTime / 60) })
        .attr('width', x.bandwidth())
        .on('mousemove', function (d) {
          tooltip
            .style('left', d3.event.pageX - 50 + 'px')
            .style('top', d3.event.pageY - 70 + 'px')
            .style('display', 'inline-block')
            .html((d.Date) + (d.Opponent) + '<br>' + (d.WowyCombo))
        })
        .on('mouseout', function (d) { tooltip.style('display', 'none') })

      var tickLabels = ['End Q1', 'End Q2', 'End Q3', 'End Q4']
      var tickValues
      if (this.$parent.league === 'wnba') {
        tickValues = [10, 20, 30, 40]
      } else {
        tickValues = [12, 24, 36, 48]
      }

      g.append('g')
        .attr('class', 'axis')
        .call(d3.axisLeft(y).tickValues(tickValues).tickFormat(function (d, i) { return tickLabels[i] }))
        .append('text')
        .attr('x', 2)
        .attr('y', y(y.ticks().pop()) + 0.5)
        .attr('dy', '0.32em')
        .attr('fill', '#000')
        .attr('font-weight', 'bold')
        .attr('text-anchor', 'start')

      g.append('g')
        .selectAll('g')
        .data(tickValues)
        .enter().append('line')
        .attr('class', 'period-break')
        .attr('x1', 0)
        .attr('y1', function (d) { return y(d) })
        .attr('x2', x(data.length) + x.bandwidth())
        .attr('y2', function (d) { return y(d) })

      if (!this.only_show_all_players_on) {
        var legendSvg = d3.select('svg#legend')
        var legendMargin = {top: 20, right: 20, bottom: 30, left: 50}
        var legendWidth = +legendSvg.attr('width') - legendMargin.left - legendMargin.right
        var gLegend = legendSvg.append('g').attr('transform', 'translate(' + legendMargin.left + ',' + legendMargin.top + ')')

        var legend = gLegend.append('g')
          .attr('font-family', 'sans-serif')
          .attr('font-size', 12)
          .attr('text-anchor', 'end')
          .selectAll('g')
          .data(wowyCombos.slice().reverse())
          .enter().append('g')
          .attr('transform', function (d, i) { return 'translate(0,' + i * 20 + ')' })

        legend.append('rect')
          .attr('x', legendWidth - 19)
          .attr('width', 19)
          .attr('height', 19)
          .attr('fill', ordinalScale)

        legend.append('text')
          .attr('x', legendWidth - 24)
          .attr('y', 9.5)
          .attr('dy', '0.32em')
          .text(function (d) { return d })
      }
    }
  }
}
</script>

<style>
.wowy-combo-playing-time-tooltip {
  position: absolute;
  display: none;
  height: auto;
  background: none repeat scroll 0 0 #ffffff;
  border: 1px solid black;
  text-anchor: middle;
  padding: 5px;
}

.margin-padding {
  border-width: 4px;
  padding: 10px;
}

svg .axis,
svg line.period-break {
  fill: none;
  stroke: black;
  stroke-width: .5;
}

</style>



// WEBPACK FOOTER //
// src/components/WowyComboPlayingTime.vue